import { useBreadcrumb } from "core/features/breadcrumbs";
import ContentMovimentacoes from "./components/ContentMovimentacoes";

function MovimentacoesBancariasListagemPage() {
  useBreadcrumb([
    { name: "Financeiro" },
    {
      name: "Movimentações Bancárias",
      url: "/financeiro/movimentacoes-bancarias",
    },
  ]);

  return <ContentMovimentacoes />;
}

export default MovimentacoesBancariasListagemPage;
